import React from "react";
import { ModalTemplate } from "../../templates/ModalTemplate";
import { PopularPlaceForm, PopularPlaceFormData } from "../form/PopularPlaceForm";
import { usePopularPlaceToast, usePopularPlaceRegistration } from "../../pages/popular_place/hook";
import { Toast } from "../../atoms/Toast";


type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit?: (data: PopularPlaceFormData) => void;
  refetchPopularPlaces?: () => void;
};

export const CreatePopularPlaceModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onSubmit,
  refetchPopularPlaces
}) => {
  const { toast, showToast, hideToast } = usePopularPlaceToast();
  const { handleRegisterPopularPlace } = usePopularPlaceRegistration(showToast, refetchPopularPlaces);

  const handleFormSubmit = (data: PopularPlaceFormData, onError: (message: string) => void) => {
    handleRegisterPopularPlace(
      data,
      onError,
      () => {
        onSubmit?.(data);
        onClose(); // Close modal on successful submission
      }
    );
  };

  if (!isOpen) return null;

  return (
    <div>
      {toast.visible && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={hideToast}
        />
      )}
      <ModalTemplate
        isOpen={isOpen}
        title="Create Popular Place"
        onClose={onClose}
      >
        <PopularPlaceForm key={isOpen ? 'open' : 'closed'} handleSubmit={handleFormSubmit} />
      </ModalTemplate>
    </div>
  );
};
